import {override} from 'mobx';
import {Collection} from '../../Common/stores/Collection';
import {PersonalMenuField} from './PersonalMenuFIeld';

export class PersonalMenuCollection extends Collection {
    insertFields(parentField, children) {
        this.fields.clear();
        children.forEach(f => {
            const newField = new PersonalMenuField(f, parentField);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }

    @override addField(field) {
        this.fields.push(field);

        const {screen} = field;
        screen.setChanged(true);
    }

    @override deleteField(field) {
        this.fields.remove(field);
        const {screen} = field;

        screen.setChanged(true);
    }
}
